/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SesionRequerida as SesionRequerida,
} from "../../runtime/index.jsx";
export function RutaConPermiso(e) {
  let t = (0, ReactCompiler.c)(3),
    { puede: n, Componente: r } = e,
    i;
  return (
    t[0] !== r || t[1] !== n
      ? ((i = (
          <SesionRequerida
            children={n() ? (0, JSXRuntime.jsx)(r, {}) : <AccesoDenegado />}
          />
        )),
        (t[0] = r),
        (t[1] = n),
        (t[2] = i))
      : (i = t[2]),
    i
  );
}
